import MediaSection from '../../../components/organisms/mediaSection';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import PropTypes from 'prop-types';
import React from 'react';

const MediaSectionTastic = ({ data, context }) => {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';

  if (!data[`show${locale}`]) return null;

  return <MediaSection data={data} />;
};

MediaSectionTastic.propTypes = {
  data: PropTypes.object.isRequired,
};

export default tastify({
  connect: { context: true },
  translate: true,
})(MediaSectionTastic);
